import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  compose, getOr, identity, map, reverse, size, sortBy, toString, uniq,
} from 'lodash/fp';
import { FormattedMessage, injectIntl } from 'react-intl';
import dayjs from 'dayjs';
import { Select } from '../../common/components';
import messages from '../messages';

const getYears = compose(
  map(year => ({
    id: year,
    value: toString(year),
    label: <FormattedMessage {...messages.yearFilterLabel} values={{ year }} />,
  })),
  array => (size(array) ? [...array] : [dayjs().year()]),
  reverse,
  uniq,
  sortBy(identity),
  map(draft => dayjs(draft.updatedAt.toDate()).year()),
  getOr([], 'data'),
);

const S = {
  Select: styled(Select)`
    width: 100%;
  `,
};

const YearFilter = ({
  drafts, intl, value, onChange,
}) => {
  const years = useMemo(() => [
    { id: 0, value: '0', label: <FormattedMessage {...messages.yearFilterLabelAll} /> },
    ...getYears(drafts),
  ], [drafts]);

  return (
    <S.Select
      id="year"
      label={intl.formatMessage(messages.yearFilterSelectLabel)}
      options={years}
      value={value}
      onChange={onChange}
    />
  );
};

YearFilter.propTypes = {
  drafts: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    data: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        number: PropTypes.shape({
          year: PropTypes.number.isRequired,
          issueNumber: PropTypes.string.isRequired,
        }),
        updatedAt: PropTypes.shape({
          seconds: PropTypes.number.isRequired,
          nanoseconds: PropTypes.number.isRequired,
          toDate: PropTypes.func.isRequired,
        }).isRequired,
      }),
    ),
  }),
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

YearFilter.defaultProps = {
  drafts: [],
};

export default injectIntl(YearFilter);
